import { faFire, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { setBanner } from "../bannerSlice";
import Navbar from "../components/Navbar";
import PlayImg from "../components/PlayImg";
import { setNotification, setNumber } from "../notificationSlice";
import reducer from "../reducer";
import { setTopic } from "../topicSlice";
// import TextCheckbox from '../components/Button';
import { RecommendRow, TopicCards } from "./Components"; // eslint-disable-line
// import RECOMMEND_TYPE from '../constant';

export default function HomePage() {
  const [state, dispatch] = React.useReducer(reducer, {
    NOTIFICATION: useSelector((state) => state.notification.list),
    BANNER: useSelector((state) => state.banner.list),
    TOPIC: useSelector((state) => state.topic.list),
    PAGE: useSelector((state) => state.notification.number),
    OPENID: new URLSearchParams(useLocation().search).get("openid"),
    CATEGORY: "国企,公务员,事业单位,教师,其它",
  });
  const reduxDispatch = useDispatch();
  // const [recommendTypes, setRecommendTypes] = React.useState({});
  const [flag, setFlag] = React.useState(true);
  const el1 = React.useRef(null);
  const el2 = React.useRef(null);
  const el3 = React.useRef(null);
  const el4 = React.useRef(null);
  const el5 = React.useRef(null);
  // eslint-disable-next-line
  // const _onCheckboxChange = ({ name, checked }) => {
  //   if (checked) {
  //     let a;
  //     if (0 < state.category.length) {
  //       a = state.category.split(',');
  //     } else a = [];
  //     a.push(name);
  //     dispatch({ type: 'set', payload: { key: 'category', value: a.join(',') } });
  //   }
  //   setRecommendTypes((types) => ({
  //     ...types,
  //     [name]: checked,
  //   }));
  //   fetch('/api/recommend/', {
  //     method: 'PUT',
  //     headers: { 'content-type': 'application/json' },
  //     body: JSON.stringify({
  //       ...recommendTypes,
  //       [name]: checked,
  //     }),
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       if (res.content) {
  //         // setRecommendList(res.content);
  //         dispatch({
  //           type: 'set',
  //           payload: { key: 'NOTIFICATION', value: res.content },
  //         });
  //         reduxDispatch(setNotification({ list: res.content }));
  //         dispatch({ type: 'set', payload: { key: 'PAGE', value: state.PAGE + 1 } });
  //       } else {
  //         alert(res.message);
  //       }
  //     });val
  // };
  const onChange = (val) => {
    dispatch({ type: "set", payload: { key: "CATEGORY", value: val } });
    if (val === "国企") {
      if (el1.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el1.current.className = "text-success bg-light";
        el2.current.className = "text-muted";
        el3.current.className = "text-muted";
        el4.current.className = "text-muted";
        el5.current.className = "text-muted";
      } else {
        el1.current.className = "text-muted";
      }
    }
    if (val === "公务员") {
      if (el2.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el2.current.className = "text-success bg-light";
        el1.current.className = "text-muted";
        el3.current.className = "text-muted";
        el4.current.className = "text-muted";
        el5.current.className = "text-muted";
      } else {
        el2.current.className = "text-muted";
      }
    }
    if (val === "事业单位") {
      if (el3.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el3.current.className = "text-success bg-light";
        el2.current.className = "text-muted";
        el1.current.className = "text-muted";
        el4.current.className = "text-muted";
        el5.current.className = "text-muted";
      } else {
        el3.current.className = "text-muted";
      }
    }
    if (val === "教师") {
      if (el4.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el4.current.className = "text-success bg-light";
        el2.current.className = "text-muted";
        el1.current.className = "text-muted";
        el3.current.className = "text-muted";
        el5.current.className = "text-muted";
      } else {
        el4.current.className = "text-muted";
      }
    }
    if (val === "其它") {
      if (el5.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el5.current.className = "text-success bg-light";
        el2.current.className = "text-muted";
        el1.current.className = "text-muted";
        el3.current.className = "text-muted";
        el4.current.className = "text-muted";
      } else {
        el5.current.className = "text-muted";
      }
    }
    load("empty", { CATEGORY: val });
  };
  const load = (option, data) => {
    const url = [
      "/api/bulletin",
      "?option=notification-wx-default",
      `&category=${data.CATEGORY}`,
      "&address_level2=",
      "&keyword=",
      `&page=${"empty" === option ? 1 : state.PAGE}`,
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        if (option === "empty") {
          dispatch({
            type: "set",
            payload: { key: "NOTIFICATION", value: data },
          });
          reduxDispatch(setNotification({ list: data }));
          dispatch({
            type: "set",
            payload: { key: "PAGE", value: state.PAGE + 1 },
          });
        } else {
          dispatch({
            type: "set",
            payload: { key: "JOB", value: state.NOTIFICATION.concat(data) },
          });
          reduxDispatch(setNotification({ list: state.NOTIFICATION.concat(data) }));
          dispatch({
            type: "set",
            payload: { key: "PAGE", value: state.PAGE + 1 },
          });
          reduxDispatch(setNumber({ number: state.PAGE + 1 }));
        }
        if (0 === data.length) {
          document.getElementById("load").innerHTML = "已经到底了";
        }
      });
  };

  const load1 = () => {
    const url = [
      "/api/bulletin",
      "?option=notification-wx-default",
      `&category=${state.CATEGORY}`,
      "&address_level2=",
      "&keyword=",
      `&page=${state.PAGE}`,
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        setFlag(true);
        dispatch({
          type: "set",
          payload: {
            key: "NOTIFICATION",
            value: state.NOTIFICATION.concat(data),
          },
        });
        reduxDispatch(setNotification({ list: state.NOTIFICATION.concat(data) }));
        dispatch({
          type: "set",
          payload: { key: "PAGE", value: state.PAGE + 1 },
        });
        reduxDispatch(setNumber({ number: state.PAGE + 1 }));
        if (0 === data.length) {
          document.getElementById("load").innerHTML = "已经到底了";
        }
      });
    setFlag(false);
  };

  React.useEffect(() => {
    document.title = "龙江学子就业平台";
  }, []);

  React.useEffect(() => {
    if (state.NOTIFICATION.length === 0) {
      load("empty", { CATEGORY: state.CATEGORY });
    }
  }, []);

  React.useEffect(() => {
    if (0 === state.BANNER.length) {
      fetch("/api/bulletin?option=banner-by-category&category=小程序-首页")
        .then((response) => response.json())
        .then((data) => {
          dispatch({ type: "set", payload: { key: "BANNER", value: data } });
          reduxDispatch(setBanner({ list: data }));
        });
    }
  }, []);

  React.useEffect(() => {
    if (state.TOPIC.length === 0) {
      fetch("/api/bulletin?option=topic-wxmp-by-limit")
        .then((response) => response.json())
        .then((data) => {
          dispatch({ type: "set", payload: { key: "TOPIC", value: data } });
          reduxDispatch(setTopic({ list: data }));
        });
    }
  }, []);

  // React.useEffect(() => {
  //   if (0 < state.CATEGORY.length) {
  //     let url = [
  //       '/api/bulletin',
  //       '?option=notification-wx-default',
  //       `&category=${state.CATEGORY}`,
  //       '&address_level2=',
  //       '&keyword=',
  //       `&page=${state.PAGE}`,
  //     ];
  //     fetch(url.join(''))
  //       .then((response) => response.json())
  //       .then((data) => {
  //         setFlag(true);
  //         if (1 === state.PAGE) {
  //           dispatch({
  //             type: 'set',
  //             payload: { key: 'NOTIFICATION', value: data },
  //           });
  //         } else if (1 < state.PAGE) {
  //           dispatch({
  //             type: 'set',
  //             payload: { key: 'NOTIFICATION', value: state.NOTIFICATION.concat(data) },
  //           });
  //           reduxDispatch(setNotification({ list: state.NOTIFICATION.concat(data) }));
  //         }
  //         dispatch({ type: 'set', payload: { key: 'PAGE', value: state.PAGE + 1 } });
  //         if (0 === data.length) {
  //           document.getElementById('load').innerHTML = '已经到底了';
  //         }
  //       });
  //     setFlag(false);
  //   }
  // }, [state.CATEGORY]);

  React.useEffect(() => {
    if (state.OPENID !== null) {
      sessionStorage.setItem("openid", JSON.stringify(state.OPENID));
    }
  }, [state.OPENID]);

  return (
    <>
      <div className="container-fluid">
        {state.BANNER.length > 0 && <PlayImg category="小程序-首页" list={state.BANNER} />}
        <div className="row pb-2 pt-2" style={{ backgroundColor: "#f5f5f5" }}>
          <div className="col">
            <input
              type="text"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照标题或城市名称查询"
              onClick={() => {
                location.href = "#主页/查询/";
              }}
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>

        <div className="p-2 bg-white user-radius card-body shadow ">
          <div>
            <h6>
              <FontAwesomeIcon icon={faFire} size="lg" className="text-danger" fixedWidth />
              热门话题
            </h6>
          </div>
          <TopicCards list={state.TOPIC} />
        </div>
        <div className="mt-2 p-2 user-radius bg-white card-body shadow ">
          <div className="row p-2">
            <div className="col">
              <h6 className="pull-left">
                <FontAwesomeIcon icon={faThumbsUp} size="lg" className="text-warning" fixedWidth />
                推荐信息
              </h6>
              <div
                className="pull-right text-muted"
                style={{
                  marginBottom: 0,
                  display: "flex",
                  paddingLeft: 0,
                  listStyle: "none",
                }}
              >
                <span ref={el1} className="text-muted" onClick={() => onChange("国企")}>
                  国企
                </span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span ref={el2} className="text-muted" onClick={() => onChange("公务员")}>
                  公务员
                </span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span ref={el3} className="text-muted" onClick={() => onChange("事业单位")}>
                  事业单位
                </span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span ref={el4} className="text-muted" onClick={() => onChange("教师")}>
                  教师
                </span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span ref={el5} className="text-muted" onClick={() => onChange("其它")}>
                  其它
                </span>
              </div>
              {/* <ul
                className="pull-right"
                style={{
                  marginBottom: 0,
                  display: 'flex',
                  paddingLeft: 0,
                  listStyle: 'none',
                }}
              >
                {RECOMMEND_TYPE.map((item) => (
                  <li className="nav-item" key={item.name}>
                    <TextCheckbox name={item.name} value={item.value} onChange={_onCheckboxChange}>
                      {item.value}
                    </TextCheckbox>
                  </li>
                ))}
              </ul> */}
            </div>
          </div>
          {state.NOTIFICATION &&
            state.NOTIFICATION.map((item) => <RecommendRow key={item.id} {...item} />)}
          {flag === true ? (
            <button id="load" className="btn btn-block mx-auto" onClick={load1}>
              点击加载更多
            </button>
          ) : (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
        </div>
        <br />
      </div>

      <Navbar category="首页" />
    </>
  );
}
